var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "consent d-inline-block" }, [
    _c(
      "span",
      [
        _vm._v("Durch das Absenden dieser Bestellung bestätigst Du "),
        _vm._v(" unsere "),
        _c("router-link", { attrs: { to: { name: "Datenschutz" } } }, [
          _vm._v("Datenschutzbestimmungen"),
        ]),
        _vm._v(". "),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }